import request from '../../../../shared/lib/request';
import { RPC } from '../../../../shared/constants';


const getDocumento = (type, praticaId, soggettoId, jobApplicationId, recessoId, reteTutorId, processoImpreseId) => request(
  {
    url: RPC.GENERA_DOCUMENTO,
    method: 'POST',
    responseType: 'blob',
    raw: true,
    data: {
      params: {
        pratica: praticaId,
        soggetto: soggettoId,
        jobApplication: jobApplicationId,
        recesso: recessoId,
        reteTutor: reteTutorId,
        processoImprese: processoImpreseId,
        from: 'web',
      },
      method: type,
    },
  });

  const getDocumentoNewContract = (praticaId, selectedOption) => request(
  {
    url: RPC.GENERA_DOCUMENTO,
    method: 'POST',
    responseType: 'blob',
    raw: true,
    data: {
      params: {
        pratica: praticaId,
        selectedOption,
        from: 'web',
      },
      method: 'genera_modulo_modifica_contratto',
    },
  });

const getContratto = (collaboratoreId) => request(
  {
    url: RPC.GENERA_DOCUMENTO,
    method: 'POST',
    responseType: 'blob',
    raw: true,
    data: {
      params: {
        collaboratore: collaboratoreId,
      },
      method: 'genera_contratto_collaboratore',
    },
  });

const GeneraDocumentoService = {
  getDocumento,
  getContratto,
  getDocumentoNewContract
};

export default GeneraDocumentoService;



// WEBPACK FOOTER //
// ./app/shared/services/rpc/genera-documento/index.js